import { useTranslation } from "react-i18next";
import { translationKey } from "../i18n";

export const StepError = ({ errorText }: { errorText: translationKey }) => {
	const { t } = useTranslation();

	return (
		<div className="row">
			<div className="col-md-12 col-sm-12 col-xs-12">
				<h3>{t("unexpectedError")}</h3>
				<p>{t(errorText)}</p>
			</div>
		</div>
	);
};
